import React from 'react';

type IconProps = {
  className?: string;
};

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export const ResumeViewIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M7 3h8l4 4v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    <path d="M15 3v4h4" />
    <path d="M8 14.5c1.2-1.2 2.6-1.8 4-1.8s2.8.6 4 1.8c-1.2 1.2-2.6 1.8-4 1.8s-2.8-.6-4-1.8z" />
    <circle cx="12" cy="14.5" r="1" />
  </svg>
);

export const ResumeAtsIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="4" y="4" width="16" height="16" rx="2" />
    <path d="M8 15v-4" />
    <path d="M12 15v-7" />
    <path d="M16 15v-5" />
    <path d="M7 10l3-3 4 4 3-5" />
  </svg>
);

export const ResumeAnalyzeIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="4.5" y="4" width="10" height="14" rx="2" />
    <path d="M7.5 8h4.5" />
    <path d="M7.5 11h4.5" />
    <circle cx="16.5" cy="15.5" r="2.5" />
    <path d="M18.2 17.2l2 2" />
  </svg>
);

export const ResumeReprocessIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M4 12a8 8 0 0 1 13.5-5.5" />
    <path d="M17.5 3v4h-4" />
    <path d="M20 12a8 8 0 0 1-13.5 5.5" />
    <path d="M6.5 21v-4h4" />
  </svg>
);

export const ResumeDeleteIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M6 7h12" />
    <path d="M9 7V5h6v2" />
    <rect x="7" y="7" width="10" height="12" rx="2" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);
